import React from 'react';
import Loader from '../../../components/Loader';
import PlaceOrderWithTerms from '../PlaceOrderWithTerms/PlaceOrderWithTerms';

const PaymentMethodMonri = ({ isOrderCreating }) => {
  return (
    <form action="" method="post" id="monri-payment-form">
      <div className="form-row">
        <div id="card-element" />
      </div>
      <PlaceOrderWithTerms isOrderCreating={isOrderCreating} />

    </form>
  );
};

export default PaymentMethodMonri;
